<template>
  <CModal :show.sync="show" :title="$pgettext('event.modal.publish.title', 'Publish')" centered>
    <template #header>
      <div>
        <div class="d-flex">
          <CIcon name="cipCheck" size="custom-size" width="36" height="36"
                 class="mr-3 icon-circle icon-circle--primary"/>
          <div>
            <h5 class="modal-title" v-translate translate-context="event.modal.create_new_event.title">Event
              Activated</h5>
            <div v-translate translate-context="event.modal.create_new_event.description">The event is now online</div>
          </div>
        </div>
      </div>

      <CButtonClose @click="show = false"/>
    </template>

    <div class="event-recap">
      <div class="title"><h5 class="m-0">{{currentEventName}}</h5></div>
      <div class="subtitle">{{currentEventSubtitle}}</div>
      <hr>
      <div class="d-flex">
        <div class="label mr-2" v-translate translate-context="event.modal.publish.start_date">Start date</div>
        <div class="value">{{currentEventStartDate|formatDate('L')}}</div>
      </div>
      <hr>
      <div class="d-flex">
        <div class="label mr-2" v-translate translate-context="event.modal.publish.timezone">Timezone</div>
        <div class="value">{{timeZone}}</div>
      </div>
    </div>


    <template #footer>
      <CButton color="primary" size="sm" @click="show = false" v-translate>Continue</CButton>
    </template>
  </CModal>
</template>

<script>
import {mapActions, mapGetters} from "vuex";


export default {
  name: "PublishedEventModal",

  data() {
    return {
      show: false,
      loading: true,
      planOptionId: null,
    }
  },
  computed: {
    ...mapGetters('event', [
      'currentEventStartDate',
      'currentEventName',
      'currentEventSubtitle',
      'timeZone'
    ]),
  },
  methods: {
    ...mapActions('event', [
      'fetchPicaService'
    ]),
    async open() {
      this.show = true
      await this.fetchPicaService(this.$route.params.picaServiceId)
      this.loading = false
    },
  }
}
</script>